<template>
  <div id="app">
    <app-header />
    <router-view />
<!--    <bg-grid :isLoaded="isLoaded" />-->
  </div>
</template>

<script>
import AppHeader from '@/components/Header'
// import BgGrid from '@/components/BackgroundGrid'

export default {
  components: {
    AppHeader
    // BgGrid
  },
  data () {
    return {
      isLoaded: false
    }
  },
  mounted () {
    this.isLoaded = true

    this.setVH()
    window.addEventListener('resize', this.setVH)
  },
  methods: {
    setVH () {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
}
</script>

<style lang="sass">
  @import './assets/styles/main.sass'
</style>
